import { getFromLocalStorage } from './localStorage';

export const brlCurrencyMask = (value) => {
  if (!value) {
    return '';
  }

  const currValue = value.toString();
  let num = currValue.replace(/\D/g, '');

  num = num.replace(/^0+/, '');

  if (num === '') {
    return 0;
  }

  num = num.length > 2 ? num : '0'.repeat(2 - num.length) + num;
  num = num.split('');

  if (num.length > 5) num.splice(-5, 0, '.');
  if (num.length === 2) num.unshift(0);

  num.splice(-2, 0, ',');

  num = num.join('');

  return num;
};

export const capitalizeEveryWord = (str) => {
  const capitalizedStr = str.toUpperCase();

  return capitalizedStr.split('').reduce((acc, char, i) => {
    if (acc[i - 1] === ' ') {
      return `${acc}${char.toUpperCase()}`;
    }

    return `${acc}${char.toLowerCase()}`;
  });
};

export const getWordAt = (str, position) => {
  const isSpace = (c) => /\s/.exec(c);
  let start = position - 1;
  let end = position;

  while (start >= 0 && !isSpace(str[start])) {
    start -= 1;
  }

  start = Math.max(0, start + 1);

  while (end < str.length && !isSpace(str[end])) {
    end += 1;
  }

  end = Math.max(start, end);

  return { start, end, word: str.slice(start, end) };
};

export const hasUpperCase = (str) => str?.toLowerCase() !== str;

const isBlogArticleValidUrl = (url) =>
  /https:\/\/www\.promobit\.com\.br\/blog\/(?!.*(\/))/.test(
    url.slice(0, url.length - 1)
  );

export const isEmailValid = (email) =>
  /^[^\s\t\r\n]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i.test(email);

export const isUrlValid = (url) =>
  /^http(s?):\/\/[a-z0-9-_.]+\.[a-z]/gi.test(url);

export const isUrlImageValid = (url) =>
  /(http(s?):)([/|.|\w|\s|-])*\.(?:jpg|jpeg|gif|png|webp)/g.test(url);

export const isUrlValidForInternalUsage = (url = '') =>
  isBlogArticleValidUrl(url) ||
  /https:\/\/www\.promobit\.com\.br\/(oferta|cupons|forum)\/(.*)/.test(url) ||
  /https:\/\/www\.promobit\.com\.br\/promocoes\/(?!.*(nova-oferta|ver-promocoes))/.test(
    url
  );

export const isTwitterUrlValid = (url = '') =>
  /(http(s)?:\/\/)?(www\.)?twitter\.com/.test(url);

export const isYoutubeUrlValid = (url = '') =>
  /(https?:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/.test(url);

/**
 * this fn format the GA Event Action prefix to a string who is able to be used
 * in already existing GA Event Actions and that they cannot be changed.
 */
export const toFormattedGaEventActionPrefix = (gaEventActionPrefix) =>
  gaEventActionPrefix ? `${gaEventActionPrefix}_` : '';

export const toFormattedJsonLdString = (string) =>
  JSON.stringify(string).replace(/(^"|"$)/g, '');

export const toFormattedRankingPosition = (positionNumber) =>
  `${positionNumber}º`;

export const toTabCount = (lastTabItemId, localStorageTabItemId) => {
  if (!lastTabItemId || !localStorageTabItemId) {
    return null;
  }

  const count =
    lastTabItemId - Number(getFromLocalStorage(localStorageTabItemId));

  if (count <= 0) {
    return null;
  }

  if (count > 99) {
    return '+99';
  }

  return count;
};

export const parseToBool = (str) => {
  if (!str) {
    return false;
  }

  if (str && typeof str === 'boolean') {
    return true;
  }

  const lowerStr = str.trim().toLowerCase();

  return ['1', 'true', 'yes'].includes(lowerStr);
};

export const sliceWithEllipsis = (str, maxLength) => {
  if (str?.length >= maxLength) {
    return `${str.substring(0, maxLength).trim()}...`;
  }

  return str;
};
